import { Box, Flex, Heading, Link } from "@theme/components";

import type { FooterDataProps } from "@theme/types";

interface FooterSocialLinksProps {
  footerData: FooterDataProps;
}

export const FooterSocialLinks = ({ footerData }: FooterSocialLinksProps) => (
  <Box>
    <Heading variant="footerSectionHeading">{footerData.headers.footerSocialTitle}</Heading>
    <Flex sx={{ gap: "s300", justifyContent: ["center", null, "flex-start"] }}>
      {footerData.socialLinks.map((link) => {
        const { title, href, Icon } = link;

        return (
          <Link
            key={`${title}-${href}`}
            rel={!footerData.isBlog ? "noopener noreferrer" : undefined}
            href={href}
            aria-label={`Follow us on ${title}`}
            title={title}
            target={!footerData.isBlog ? "_blank" : undefined}
            sx={{
              width: "auto",
              color: "textLevel3",
              padding: "s100",
              alignContent: "center",
              ":hover": {
                color: "textBrand",
              },
              "> svg": {
                height: [20, null, 24],
              },
            }}
          >
            <Icon />
          </Link>
        );
      })}
    </Flex>
  </Box>
);
